import { Component, Input } from "@angular/core";

@Component({
  selector: "app-step-counter",
  template: `<div class="d-flex align-items-center mb-1">
      <div class="color-box bg-light-{{color}} px-1 py-1" [style.border-radius.rem]=".357">
        <i [data-feather]="icon" size="22"></i>
      </div>
      <div class="ml-1">
        <h5 class="mb-0 font-weight-bold">{{ count }}</h5>
        <small>{{ "STEPS_STATS." + title | translate }}</small>
      </div>
    </div>
  `,
})
export class StepCounterComponent {
  @Input() icon: string = "";
  @Input() title: string = "";
  @Input() count: number = 0;
  @Input() color: string = "secondary";
}
